// extracted by css-extract-rspack-plugin
export default {"topContainer":"LexRa2iWjoWRuXrY","chipContainer":"CAt1r1JsU_IIMibH"};